import { useEffect } from 'react';
export function useDynamicFavicon({
  faviconUrl
}) {
  useEffect(() => {
    if (!faviconUrl) {
      return;
    }

    // Remove all existing favicon elements to avoid conflicts
    document.querySelectorAll('link[rel*="icon"]').forEach(el => el.remove());
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';
    favicon.href = faviconUrl;
    document.head.appendChild(favicon);
  }, [faviconUrl]);
}